import { render, staticRenderFns } from "./ResultComparisonInsights.vue?vue&type=template&id=633dc601&scoped=true&"
import script from "./ResultComparisonInsights.vue?vue&type=script&lang=js&"
export * from "./ResultComparisonInsights.vue?vue&type=script&lang=js&"
import style0 from "./ResultComparisonInsights.vue?vue&type=style&index=0&id=633dc601&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633dc601",
  null
  
)

export default component.exports